import { render, staticRenderFns } from "./IncluirTerritorio.vue?vue&type=template&id=2f6ac6da&lang=pug"
import script from "./IncluirTerritorio.vue?vue&type=script&lang=js"
export * from "./IncluirTerritorio.vue?vue&type=script&lang=js"
import style0 from "./IncluirTerritorio.vue?vue&type=style&index=0&id=2f6ac6da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports